export const isJobcloudAi = (): boolean => window.location.hostname.endsWith('jobcloud.ai');

export const getJobcloudBrand = () => (isJobcloudAi() ? 'Jobcloud.ai' : 'JobCloud');

export const getJobcloudDomain = () => (isJobcloudAi() ? 'jobcloud.ai' : 'one.jobcloud.ch');

export const getInfoEmail = () => (isJobcloudAi() ? 'info@jobcloud.ai' : 'info@jobcloud.ch');

export const getNoReplyEmail = () =>
  isJobcloudAi() ? 'noreply@jobcloud.ai' : 'noreply@jobcloud.ch';
